import { gsap } from 'gsap';

import sniffer from '../../utils/sniffer';

const mysnif = sniffer.infos;


class UnBluringImages {
    constructor() {
        this.DOM = { $unblurElems: [...document.querySelectorAll('.unBlur')] }
        this.fireOnce = true;
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!mysnif.isSafari) {

                        gsap.timeline({ delay: .25, })
                            .to(entry.target, {
                                scale: 1,
                                duration: .75
                            })
                            .to(entry.target, {
                                filter: 'brightness(1) blur(0px)',
                                duration: 1,
                            }, "-=.5")
                    } else {
                        gsap.to(entry.target, {
                            delay: .25,
                            skewX: 0, skewY: 0,
                            x: 0, y: 0,
                            scale: 1, duration: .75
                        })
                    }


                    if (this.fireOnce) this.observer.unobserve(entry.target)
                } else {
                    if (!mysnif.isSafari) {
                        gsap.set(entry.target, {
                            filter: 'brightness(15) blur(320px)',
                            scale: .5
                        })
                    } else {
                        gsap.set(entry.target, {
                            skewX: 50, skewY: 50,
                            x: -50, y: -150,
                            scale: .15
                        })
                    }
                }
            });
        }, {

        });
        this.init()
    }
    init() {
        this.initObervation()
    }

    initObervation() {
        this.DOM.$unblurElems.forEach(elem => this.observer.observe(elem))
    }
}

const myObserver = new UnBluringImages()





